<script setup>
import { computed } from 'vue';
import numeral from 'numeral';
import pn from 'persian-number';

// 1. تعریف پراپ‌ها (Props) برای دریافت داده و تنظیمات از کامپوننت والد
const props = defineProps({
  // این پراپ برای کار با v-model ضروری است
  modelValue: [String, Number],
  
  // پراپ‌های دیگر برای شخصی‌سازی
  label: String,
  placeholder: String,
  moneyUnit: {
    type: String,
    default: 'ریال' // واحد پول پیش‌فرض
  },
  isRequired: {
    type: Boolean,
    default: false
  },
  format: {
    type: String,
    default: '0,0' // فرمت جداسازی ارقام
  },
  error: String // برای نمایش پیام خطا
});

// 2. تعریف رویدادها (Emits) برای ارسال تغییرات به بیرون
const emit = defineEmits(['update:modelValue']);

// 3. استفاده از Computed Property برای مدیریت v-model
// این بخش کلیدی‌ترین قسمت برای کار با v-model و قالب‌بندی همزمان است
const displayValue = computed({
  // GET: این تابع مقدار خام (modelValue) را می‌گیرد و آن را برای نمایش در اینپوت، فرمت‌بندی می‌کند
  get() {
    if (props.modelValue === null || props.modelValue === undefined || props.modelValue === '') {
      return '';
    }
    // مقدار عددی را به فرمت رشته‌ای با جداکننده کاما تبدیل می‌کند (مثلا: 1500000 -> "1,500,000")
    return numeral(props.modelValue).format(props.format);
  },
  
  // SET: این تابع زمانی اجرا می‌شود که کاربر مقداری را در اینپوت وارد می‌کند
  set(newValue) {
    // مقدار رشته‌ای فرمت‌شده را به عدد خام تبدیل می‌کند (مثلا: "1,500,000" -> 1500000)
    const rawNumber = numeral(newValue).value();
    // عدد خام را از طریق رویداد 'update:modelValue' به کامپوننت والد ارسال می‌کند تا v-model به‌روز شود

    emit('update:modelValue', rawNumber);
    // setTimeout(() => {
    // }, 1000);
  }
});

// 4. یک Computed Property برای نمایش عدد به حروف
const numbersAsText = computed(() => {
  const numberValue = props.modelValue;
  if (!numberValue) return ''; // اگر مقداری وجود نداشت، چیزی نمایش نده
  // عدد را به حروف فارسی تبدیل کرده و واحد پول را به آن اضافه می‌کند
  return `${pn.convert(numberValue)} ${props.moneyUnit}`;
});

</script>

<template>
  <div class="w-full flex flex-wrap">
    <label v-if="label" class="block mb-2 text-sm font-medium text-gray-900">
        <span v-if="label">
          {{ label }}
          <span v-if="isRequired" class="text-red-500">*</span>
        </span>
        <span v-if="numbersAsText" class="form-text">
           ( {{ numbersAsText }} )
        </span>
    </label>

    <input
      type="text"
      class="w-full form-control form-input form-input-bordered"
      :class="{ 'is-invalid': error }"
      :placeholder="placeholder"
      v-model="displayValue"
      v-bind="$attrs"
    />

    
    
    <div v-if="error" class="invalid-feedback">{{ error }}</div>
  </div>
</template>

<style scoped>
/* استایل‌های پایه برای نمایش بهتر - می‌توانید از کلاس‌های فریمورک خود مثل Bootstrap یا Tailwind استفاده کنید */
.form-label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
}

.form-text {
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #6c757d;
}
.is-invalid {
    border-color: #dc3545;
}
.invalid-feedback {
    display: block;
    width: 100%;
    margin-top: 0.25rem;
    font-size: .875em;
    color: #dc3545;
}
</style>